export const setCS2 = (out, x, y, io = 0, so = 1) => (!out && (out = []), (out[io] = x), (out[io + so] = y), out);
export const setCS3 = (out, x, y, z, io = 0, so = 1) => (!out && (out = []),
    (out[io] = x),
    (out[io + so] = y),
    (out[io + 2 * so] = z),
    out);
export const setCS4 = (out, x, y, z, w, io = 0, so = 1) => (!out && (out = []),
    (out[io] = x),
    (out[io + so] = y),
    (out[io + 2 * so] = z),
    (out[io + 3 * so] = w),
    out);
